import { post } from '../../api/api';

export const createAiJobDescriptionLog = async (jobId: number) =>
  post(`/ai-job-description-log`, {
    body: JSON.stringify({ jobId }),
  }).then((response) => response.json());
